<template>
    <ui-modal :width="832" :height="536" spacing="32px 56px 48px" ref="modal">
        <div>
            <!-- * 标题 -->
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("AddToFavorites") }}</div>
            <!-- * 内容 -->
            <div class="mt-[16px] pt-[16px] px-[24px] pb-[24px] bg-[#F9FAFD]">
                <div class="mb-[4px]">{{ $t("SelectAFavorites") }}</div>
                <ui-select
                    v-model="data.name"
                    :candidates="candidates"
                    :placeholder="$t('PleaseSelectAFavorites')"
                    :zIndex="667"
                    width="100%"
                    v-loading="loading"></ui-select>

                <div class="mt-[8px] mb-[4px]">{{ $t("Description3") }}</div>
                <ui-textarea
                    v-model="data.descript"
                    :height="166"
                    :maxlength="200"
                    style="--uioption-textarea-spacing-y: 8px"
                    :placeholder="$t('FavoriteDesc')" />
            </div>

            <!-- * 按钮组 -->
            <div class="mt-[24px] flex justify-between">
                <UiButton
                    size="middle"
                    :width="160"
                    @click="
                        methods.close();
                        emits('new');
                    "
                    >{{ $t("NewFavorites") }} >></UiButton
                >
                <div>
                    <UiButton :class="css_button.cancel" size="middle" :width="104" @click="methods.close">{{ $t("Cancel") }}</UiButton>
                    <UiButton class="ml-[16px]" size="middle" :width="104" :disabled="disabled" @click="methods.confirm">
                        {{ $t("Confirm") }}
                    </UiButton>
                </div>
            </div>
        </div>
    </ui-modal>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal, UiButton, UiTextarea, UiSelect } from "various-ui";
import type { UiTypes } from "various-ui";
//* 样式
import css_button from "@/assets/style/src/button.module.less";

//* 组件属性注册
const emits = defineEmits({
    new: () => true,
    confirm: (_response: { name: string; descript: string }) => true,
});

//* 响应式数据
const candidates = ref<UiTypes.candidate[]>([]);
const loading = ref<boolean>(false);
//* 表单数据
const data = reactive({ name: "", descript: "" });
//* 节点
const modal = ref<InstanceType<typeof UiModal>>();
//* 计算属性
const disabled = computed(() => {
    return !data.name.trim();
});

//* 函数列表
const methods = {
    //* 激活事件
    open: (response?: any) => {
        //* 数据初始化
        data.name = response?.name || "";
        data.descript = response?.descript || "";
        //* 打开弹窗
        modal.value?.openModal();
        //* 获取收藏夹列表
        loading.value = true;
        api.frontend("/api/user/favorites", {
            data: {
                page: 1,
                limit: 100,
            },
            headers: { "X-Token": useCookie("X-Token").value || "" },
            finally: () => (loading.value = false),
            success: (response) => {
                candidates.value =
                    response.data?.map((value: any) => ({
                        label: value.name,
                        value: value.id,
                    })) || [];
            },
        });
    },

    //* 关闭事件
    close: () => modal.value?.closeModal(),
    //* 确认事件
    confirm: () => {
        emits("confirm", data);
    },
};

//* 组件属性导出
defineExpose({
    open: methods.open,
    close: methods.close,
});
</script>
